<template>
  <vue-simplebar id="forgot-password" class="panel">
    <h3 class="font-mdish wt-md align-center">Reset Password</h3>

    <form class="{loading: loading}" @submit.prevent="sendEmail">
      <div class="alert danger" v-if="authMessage">
        <p>{{ authMessage }}</p>
      </div>

      <div class="alert info">
        <p>
          Forgot your password?<br/>
          Simply enter your email address below we will send you a link to reset it.
        </p>
      </div>

      <div class="form-group vanilla">
        <label for="forgot-password-email">Email address</label>
        <input id="forgot-password-email" type="text" v-model="email" required/>
      </div>

      <div class="alert danger" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="form-group vanilla submit">
        <loader-button type="submit" :loading="loading" label="Reset my password" class="block"></loader-button>
      </div>
    </form>
  </vue-simplebar>
</template>

<script>
export default {
  data () {
    return {
      email: null,
      loading: false,
      error: null
    }
  },
  computed: {
    authMessage () {
      return this.$store.getters['user/authMessage']
    }
  },
  methods: {
    sendEmail () {
      if (!this.loading) {
        this.error = null
        this.loading = true

        axios.post('/api/auth/reset-password', {
          email: this.email
        })
            .then(response => {
              this.email = null
              this.$toasted.show('Please check your email and follow the instructions we sent to you', {
                type: 'success'
              })
            })
            .catch(error => {
              this.$toasted.show('We couldn\'t send your reset link, please wait 5 minutes and try again', {
                type: 'error'
              })
            })
            .then(() => {
              this.loading = false
            })
      }
    }
  }
}
</script>
